/**
 * Primary nav / global-search hrefs that are intentionally not implemented yet.
 * Burn-down list: remove an entry when its screen lands (guard will fail if the
 * href becomes a defined route while still listed here).
 */
export const KNOWN_MISSING_NAV_ROUTES = {
  // Agency
  '/agency/activity': 'Team activity feed screen not built yet.',
  '/agency/listings': 'Agency-scoped listings view not built; agents use /listings.',
  '/agency/channels': 'Agency channels management screen not built yet.',
  '/agency/subscription': 'Agency subscription screen not built; agents use /my-subscription.',
  '/agency/invoices': 'Agency invoices screen not built; agents use /my-invoices.',
  '/agency/members': 'Members directory not built; applications queue is at /agency/members/applications.',
  '/agency/white-label': 'White-label hub not built; copy/analytics sub-routes exist separately.',

  // Agent
  '/templates': 'Agent templates hub not built; message templates live at /message-templates.',
  '/channels': 'Top-level channels hub not built; settings channels live at /settings/channels.',
  '/routing': 'Top-level routing hub not built; settings routing lives at /settings/routing.',
  '/help': 'In-app help centre not built yet.',

  // Platform admin
  '/admin/approvals': 'Top-level approvals queue not built; package approvals are at /admin/packages/approvals.',
  '/admin/pva': 'Property valuation admin hub not built; price reports live at /admin/valuation/price-reports.',
  '/admin/fin/vendors': 'Vendor list screen not built; vendor detail is at /admin/fin/vendors/:id.',
  '/admin/fin/rates': 'Vendor rates screen not built yet.',
  '/admin/fin/statements': 'Statements list screen not built; statement detail is nested under vendors.',
  '/admin/credits': 'Top-level credit grants not built; fin credits live at /admin/fin/credits.',
  '/admin/moderation': 'Moderation hub not built; portal queue is at /admin/moderation/portals.',
  '/admin/acr': 'Short ACR alias not built; queue lives at /admin/support/account-recovery.',
  '/admin/cfg': 'System config alias not built; fin configuration is at /admin/fin/configuration.',
  '/admin/tpl': 'Templates short alias not built; platform templates are at /admin/message-templates.',
  '/admin/notifications': 'Notifications hub not built; dead-letter is at /admin/notifications/dead-letter.',
} as const

export type KnownMissingNavRoute = keyof typeof KNOWN_MISSING_NAV_ROUTES
